import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUsuarioCreacionModel } from '../../../modelos/Usuario/modeloUsuario';
import { useAuth } from '../../../metodos/AuthContext';

const ConfirmarNumero = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { setupSMSverification } = useAuth();
    
    // Referencia para el contenedor de reCAPTCHA
    const recaptchaWrapperRef = useRef(null);
    
    const datosPendientes = location.state?.datosPendientes;
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [cargando, setCargando] = useState(false);
    const [confirmationResult, setConfirmationResult] = useState(null);
    const { confirmarCodigoYCrearUsuario } = useUsuarioCreacionModel();

    useEffect(() => {
        if (!datosPendientes) {
            toast.error("Datos perdidos, intenta de nuevo.");
            navigate('/registro-cliente');
            return;
        }
        // Pequeño delay para asegurar que el ref se asigne al DOM
        const timer = setTimeout(() => {
            enviarSMS();
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    const [enviando, setEnviando] = useState(false);
    const enviarSMS = async () => {
        if (enviando) return; // Si ya se está enviando, no hagas nada
        if (!recaptchaWrapperRef.current) return;

        setEnviando(true);
        setCargando(true);
        try {
            const result = await setupSMSverification(datosPendientes.numero, recaptchaWrapperRef.current);
            setConfirmationResult(result);
        } catch (error) {
            // ... manejo de error
        } finally {
            setEnviando(false);
            setCargando(false);
        }
    };

    const handleOtpChange = (element, index) => {
        if (isNaN(element.value)) return;
        const nuevoOtp = [...otp];
        nuevoOtp[index] = element.value;
        setOtp(nuevoOtp);
        if (element.nextSibling && element.value) element.nextSibling.focus();
    };

    const verificarYRegistrar = async (e) => {
        e.preventDefault();
        const code = otp.join('');
        if (code.length < 6) return toast.warn("Completa el código");

        setCargando(true);
        try {
            await confirmationResult.confirm(code);
            
            const exito = await confirmarCodigoYCrearUsuario(
                datosPendientes.correoElectronico, 
                '', 
                datosPendientes,
                true,
            );

            if (exito) {
                toast.success("¡Registro completado con éxito!");
                navigate('/login');
            }
        } catch (error) {
            console.error("Error en verificación:", error);
            toast.error("Código inválido o expirado");
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center">
            {/* Contenedor vinculado al Ref */}
            <div ref={recaptchaWrapperRef}></div>

            <div className="bg-white p-8 rounded-lg shadow-xl max-w-md w-full text-center">
                <h2 className="text-2xl font-bold mb-4">Verifica tu Celular</h2>
                <p className="text-gray-500 mb-6">Enviamos un SMS al {datosPendientes?.numero}</p>

                <form onSubmit={verificarYRegistrar}>
                    <div className="flex justify-center gap-2 mb-8">
                        {otp.map((digit, idx) => (
                            <input
                                key={idx}
                                type="text"
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleOtpChange(e.target, idx)}
                                className="w-10 h-12 border-2 rounded text-center text-xl focus:border-blue-500 outline-none"
                            />
                        ))}
                    </div>

                    <button
                        type="submit"
                        disabled={cargando || !confirmationResult}
                        className="w-full bg-blue-600 text-white py-3 rounded-lg font-bold hover:bg-blue-700 disabled:bg-gray-400"
                    >
                        {cargando ? 'Verificando...' : 'Finalizar Registro'}
                    </button>
                </form>

                <button 
                    onClick={enviarSMS}
                    className="mt-4 text-blue-600 text-sm hover:underline"
                    disabled={cargando}
                >
                    Reenviar código
                </button>
            </div>
        </div>
    );
};

export default ConfirmarNumero;